import { VariableScope } from 'job-lib/types/Variables'

import { Fields, FormState } from 'modules/ManageVariables/types'

const jobVariableFields = [
  Fields.NAME,
  Fields.DESCRIPTION,
  Fields.VARIABLE_TYPE,
  Fields.VISIBILITY,
  Fields.DEFAULT_VALUE
]

const projectVariableFields = [
  Fields.NAME,
  Fields.DESCRIPTION,
  Fields.VARIABLE_TYPE,
  Fields.DEFAULT_VALUE,
  Fields.PROJECT_DEFAULT_OVERRIDES
]

export const isFormValid = (state: FormState): boolean => {
  if (state.VARIABLE_SCOPE.value === VariableScope.JOB_VARIABLE) {
    return jobVariableFields.every((field) => state[field].isValid)
  }

  return projectVariableFields.every((field) => state[field].isValid)
}
